module.exports = __webpack_public_path__ + "static/media/hotjar-logo.43555210.png";